import { sumBy } from 'lodash';
import { mapActions, mapGetters, mapState } from 'vuex';
import marketContractHorizontalSushi from '@/components/market/market-contract-horizontal-sushi/market-contract-horizontal-sushi.vue';
import marketContractHorizontalSushiMobile from '@/components/market/market-contract-horizontal-sushi-common-betslip/market-contract-horizontal-sushi-common-betslip.vue';
import marketContractsListHeaderSushi from '@/components/market/market-contracts-list-header-sushi/market-contracts-list-header-sushi.vue';
import purchaseInlineSushi from '@/components/purchase/sushi/purchase-inline-sushi/purchase-inline-sushi.vue';
import marketPayoutSushi from '@/components/market/market-payout-sushi/market-payout-sushi.vue';
import loaderMixin from '@/mixins/loader';
import Contract from '@/models/contract';
import { contractOwnershipNum, hasMarketPayout } from '@/utils/helpers';
import scrollTo from '@/utils/scrollTo';
import { MODALS } from '@/components/app/app-modals/app-modals';
// transition time + buffer
export const OFFSET_CHECK_TIMEOUT = 300 + 150;
export const MARKET_CONTRACTS_SHOW_MORE_NUM = 3;

export default {
  props: {
    market: {
      type: Object,
      required: true,
    },
    expandingAll: {
      type: Boolean,
      default: false,
    },
    expanded: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showAllContracts: false,
      isExpandingAll: this.expandingAll,
      togglePositionTop: null,
    };
  },
  mixins: [
    loaderMixin,
  ],
  components: {
    marketContractHorizontalSushi,
    marketContractHorizontalSushiMobile,
    marketContractsListHeaderSushi,
    marketPayoutSushi,
    purchaseInlineSushi,
  },
  computed: {
    ...mapGetters('app', ['isLayoutDesktop', 'isLayoutMobile']),
    ...mapGetters('user', ['isLoggedIn']),
    ...mapState('trade', ['tradeOptions', 'hidePurchaseForContractId']),
    ...mapState('popup', ['currentPopup']),
    contractsToShow() {
      return (!this.showAllContracts && this.shouldShowToggleMoreButton) ?
        this.filteredContracts.slice(0, MARKET_CONTRACTS_SHOW_MORE_NUM) :
        this.filteredContracts;
    },
    leftContractsToShow() {
      return this.showAllContracts ?
        [] :
        this.filteredContracts.slice(MARKET_CONTRACTS_SHOW_MORE_NUM, this.filteredContracts.length);
    },
    shouldShowToggleMoreButton() {
      return this.expandingAll && this.filteredContracts.length > MARKET_CONTRACTS_SHOW_MORE_NUM;
    },
    classModifiers() {
      return {
        'market-list-item-expandable-sushi': true,
        'market-list-item-expandable-sushi--expanded': this.expanded
      }
    },
    toggleMoreModifiers() {
      return {
        'market-list-item-expandable-sushi__contracts-toggle-more': true,
        'market-list-item-expandable-sushi__contracts-toggle-more--active': this.showAllContracts,
      };
    },
    titleClassModifiers() {
      return {
        'market-list-item-expandable-sushi__title': true,
        'market-list-item-expandable-sushi__title--has-open-offers': this.showOpenOffersIndicator,
      };
    },
    toggleClassModifiers() {
      return {
        'market-list-item-expandable-sushi__toggle': true,
        'market-list-item-expandable-sushi__toggle--expanded': this.expanded,
      };
    },
    marketImageStyleModifiers() {
      const baseGradient = 'linear-gradient(to right, rgba(78, 109, 115, 0.12), rgba(78, 109, 115, 0.16))';
      return {
        'background-image': `${baseGradient}, url(${this.market.marketImageUrl})`,
      };
    },
    filteredContracts() {
      return (this.market && this.market.marketContracts) ?
        this.market.marketContracts.filter(i => contractOwnershipNum(i) > 0) :
        [];
    },
    isPayoutAvailable() {
      return hasMarketPayout(this.market);
    },
    openOffers() {
      if (!this.market.isOpen) return 0;
      return sumBy(
        this.filteredContracts,
        i => i.userOpenOrdersBuyQuantity + i.userOpenOrdersSellQuantity,
      );
    },
    showOpenOffersIndicator() {
      return this.isLayoutDesktop && this.openOffers > 0;
    },
    marketKey() {
      const loggedIn = (this.isLoggedIn) ? 'logged-in' : 'logged-out';
      return this.market ? `dashboard-${this.market.marketId}-${loggedIn}` : null;
    },
  },
  methods: {
    ...mapActions('market', ['getMarket']),
    ...mapActions('popup', ['setTradePopup']),
    onToggleMore() {
      this.showAllContracts = !this.showAllContracts;
      if (!this.showAllContracts) {
        window.scrollTo(0, this.$el.offsetTop);
      }
    },
    onViewMarket(market) {
      this.$router.push({
        name: 'market-details',
        params: { marketId: market.marketId, marketUrl: market.marketUrl },
      });
    },
    toggleItem() {
      this.togglePositionTop = this.$el.offsetTop;
      this.$emit('toggle', {
        expanded: !this.expanded,
        market: this.market,
      });
    },
    contractKey(prefix, data) {
      const contract = new Contract(data);
      return `${prefix}-${this.marketKey}-${contract.contractId}-${contract.mode}`;
    },
    isPurchaseInlineMode(contractId) {
      return this.tradeOptions &&
        this.tradeOptions.contractId === contractId;
    },
    initializePurchase() {
      const contracts = this.market.contracts || this.market.marketContracts;
      const contractIds = contracts.map(i => i.contractId);
      if (
        this.isLayoutMobile &&
        this.tradeOptions !== null &&
        this.tradeOptions.contractId !== null &&
        contractIds.includes(this.tradeOptions.contractId) &&
        this.currentPopup !== MODALS.PURCHASE_SUSHI &&
        false
      ) {
        this.setTradePopup({
          name: MODALS.PURCHASE_SUSHI,
          options: {
            market: this.market,
          },
        });
      }
    },
  },
  watch: {
    // expanded(value) {
    //   if (value && !this.expandingAll) {
    //     setTimeout(() => {
    //       scrollTo(this.$el.offsetTop, 500);
    //     }, OFFSET_CHECK_TIMEOUT);
    //   }
    // },
    tradeOptions() {
      this.initializePurchase();
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/market/market-list-item-expandable-sushi/market-list-item-expandable-sushi.js